import { render } from "./newFormSmall.vue?vue&type=template&id=23cd1922&scoped=true"
import script from "./newFormSmall.vue?vue&type=script&lang=js"
export * from "./newFormSmall.vue?vue&type=script&lang=js"

import "./newFormSmall.vue?vue&type=style&index=0&id=23cd1922&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cd1922"]])

export default __exports__